import React from 'react';

import Spinner from '@/components/common/Spinner/Spinner';

import './fullscreen-spinner.scss';


export default function FullScreenSpinner() {
  return (
    <div className="ag-fullscreen-spinner">
      <div className="ag-fullscreen-spinner__wrapper">
        <span>
          <Spinner />
        </span>
      </div>
    </div>
  );
}
